(function () {
    function initBusinessBannerAnimation() {
        var icon = document.querySelector('[data-business-banner-icon]');
        if (!icon) return;

        var fillPath = icon.querySelector('.business-banner__fill-path');
        if (!fillPath) return;

        var pathLength = fillPath.getTotalLength();

        if (
            typeof window.gsap === 'undefined'
            || window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
            fillPath.style.strokeDashoffset = '0';
            return;
        }

        window.gsap.set(fillPath, {
            strokeDasharray: pathLength,
            strokeDashoffset: pathLength
        });

        function playAnimation() {
            window.gsap.to(fillPath, {
                strokeDashoffset: 0,
                duration: 1,
                ease: 'none'
            });
        }

        if (!('IntersectionObserver' in window)) {
            playAnimation();
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                playAnimation();
                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.35
        });

        observer.observe(icon);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBusinessBannerAnimation);
    } else {
        initBusinessBannerAnimation();
    }
})();
